import { render, staticRenderFns } from "./scoreEvaluationnew.vue?vue&type=template&id=c13e112e&scoped=true"
import script from "./scoreEvaluationnew.vue?vue&type=script&lang=js"
export * from "./scoreEvaluationnew.vue?vue&type=script&lang=js"
import style0 from "./scoreEvaluationnew.vue?vue&type=style&index=0&id=c13e112e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13e112e",
  null
  
)

export default component.exports